const mutations = {
  setRecurrent(state, recurrent) {
    state.recurrent = recurrent;
  },
  setRecurrents(state, recurrents) {
    state.recurrents = recurrents;
  },
  setHistorical(state, recurrentHistorical) {
    state.recurrentHistorical = recurrentHistorical;
  },
  setTotal(state, total) {
    state.total = total;
  },
};

export default mutations;
